// @flow
import { List } from 'immutable';

import * as types from './types';

export function transformTagToRequestData(tag: types.Tag) {
  return {
    id: tag.id,
    name: tag.name,
    isDeleted: tag.isDeleted,
    description: tag.description,
    type: tag.type,
    clientId: tag.clientId,
    createdAt: tag.createdAt,
  };
}

export function transformResponseToTags(response: any) {
  return response.data.resources.map((data) => (
    types.mkTag({
      id: data.id,
      name: data.name,
      isDeleted: data.isDeleted,
      description: data.description,
      type: data.type,
      clientId: data.clientId,
      createdAt: data.createdAt,
    })
  ));
}

export function transformTagsToRequestData(tags: List<types.Tag> | Array<types.Tag>) {
  const resources = tags.reduce((list, tag) => {
    list.push(transformTagToRequestData(tag));
    return list;
  }, []);

  return {
    resources,
  };
}

